import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from "../views/HomeView";
// import Loading from "../views/Loading";
// import Splash from "../views/Splash";
// import FullContent from "../views/FullContent";

Vue.use(VueRouter);

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HomeView',
      component: HomeView,
    },
  ]
})

export default router
